import ready from "../utils/ready";
import Parvus from 'parvus';

ready(() => {
  const prvs = new Parvus({
    gallerySelector: '.gallery',
  });
});
